import React from "react";
import SlideButton from 'react-slide-button';
import biglogo from "../assets/biglogo.png";
import configData from "../config.json";

const ResetPassword = () => {
    const [username, setUsername] = React.useState("");
    const [fail, setFail] = React.useState("");

    const setUser = (e) => { setUsername(e.target.value) }

    const Submit = () => {
        var url = `${configData.SERVER_URL}apiV7/resetpassword`;
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            mode: "cors",
            body: JSON.stringify({
                "userName": username,
                "password": "reset"
            }),
        }).then(response => response.text()).then(d => {
            setFail(d);
        });
    }

    return (
        <div className="App">
            <div className="container" id="container">
                <div>
                    <div >
                        <div className="form-container sign-in-container" style={{ background: "#021417" }} >
                            <form>
                                <img src={biglogo} alt="EZYweigh" style={{ maxHeight: "380px" }} />
                                <h1 style={{ color: "white" }}>Reset Password</h1>
                                <input
                                    required
                                    type="text"
                                    placeholder="User Name"
                                    name="username"
                                    value={username}
                                    onChange={setUser}
                                    style={{ margin: "3px 0px" }}
                                />
                                {fail && <h6 style={{ color: "red" }}>{fail}</h6>}
                                <div style={{ background: "white" }}>
                                    <SlideButton className="slide-submit"
                                        mainText="Slide to Enter"
                                        overlayText="Submitted"
                                        caretClassList="my-caret-class"
                                        overlayClassList="my-overlay-class"
                                        onSlideDone={Submit}
                                        reset={() => setUsername("")}
                                    />
                                </div>
                            </form>
                        </div>
                        <footer>
                            <p>
                                <a href="/login">
                                    <b>Login</b>
                                </a>
                                &nbsp; &nbsp; &nbsp;
                                <a href="https://wms.screenconnect.com" target="_blank">
                                    <b>Remote Support</b>
                                </a>
                                &nbsp; &nbsp; &nbsp;
                                <a href="https://weigh-more.com.au/contact/" target="_blank">
                                    <b>Contact Us</b>
                                </a>
                                &nbsp; &nbsp; &nbsp;
                                <a href="https://weigh-more.com.au/about-us/" target="_blank">
                                    <b>About</b>
                                </a>
                            </p>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;
